import StepLabel from './styles';

export default StepLabel;
